export default __webpack_public_path__ + "static/media/gallery_02.f24e08c3.jpg";